<div class="calibration-container">
  <video #video style="display: none;" autoplay muted playsinline></video>
  <canvas #canvas style="display: none;"></canvas>

  <div *ngIf="cameraReady" class="target"
    [class.target-confirmed]="confirmed"
    [class.target-busy]="recording || finishing"
    [style.left]="calibrationPoints[currentIndex].x"
    [style.top]="calibrationPoints[currentIndex].y"
    (click)="captureCurrentPoint()">
    <fa-icon *ngIf="!confirmed" [icon]="faCrosshairs" class="target-icon target-icon-crosshairs" size="2x"></fa-icon>
    <fa-icon *ngIf="confirmed" [icon]="faCheck" class="target-icon target-icon-check" size="2x"></fa-icon>
  </div>

  <div class="status fw-bold text-uppercase text-wrap">
    <div class="spinner-border text-primary" role="status" *ngIf="!cameraReady || finishing || (recording && !confirmed)">
      <span class="visually-hidden">Loading...</span>
    </div>
    <ng-container *ngIf="cameraReady; else preparingCamera">
      <ng-container *ngIf="finishing; else clickTargetPrompt">
        Saving calibration...
      </ng-container>
      <ng-template #clickTargetPrompt>
        Click the target at the {{calibrationPoints[currentIndex].name}} to calibrate your screen.
      </ng-template>
    </ng-container>
    <ng-template #preparingCamera>
      Preparing webcam for calibration...
    </ng-template>
  </div>
</div>
